import React from "react";
import printJS from "print-js";
import { pdf } from "@react-pdf/renderer";
import { PDFDocument } from "../table/PDFDocument";
import { useFormContext } from "react-hook-form";
import { CreateBillDto } from "../model/bill/dto/CreateBillDto";

type PrintButtonProps = {};

export const PrintButton: React.FC<PrintButtonProps> = () => {
  const { getValues } = useFormContext<CreateBillDto>();

  const onPrint = async () => {
    const dto = getValues();

    dto.soldTo = dto.soldTo.trim();
    dto.receivedBy = dto.receivedBy.trim();
    dto.billDetails.forEach(
      (b) =>
        (b.amount = (Number(b?.qty || 0) * Number(b?.unitPrice || 0)).toFixed(
          2
        ))
    );

    const blob = await pdf(<PDFDocument dto={dto} />).toBlob();

    if (!blob) {
      console.error("No blob found in the document");
      return;
    }

    printJS({
      printable: URL.createObjectURL(blob),
      type: "pdf",
      showModal: true,
    });
  };

  return (
    <button className="btn btn-secondary border-0" onClick={onPrint}>
      Print
    </button>
  );
};
